<div class="offcanvas-header">
  <h5 class="mb-0 offcanvas-title" id="offcanvasRightLabel">
    {{ frmText }}
  </h5>
  <button
    #closeAccrBtn
    type="button"
    class="btn-close"
    data-bs-dismiss="offcanvas"
    aria-label="Close"
    #closeBtn
  ></button>
</div>

<div class="offcanvas-body p-3 d-flex flex-column mb-3">
  <div class="container-fluid">
    <div class="mb-2">
      <label for="name" class="form-label required">Name</label>
      <input
        type="text"
        class="form-control"
        placeholder="Enter Name"
        name="name"
        #name="ngModel"
        [(ngModel)]="carrierObj.name"
        id="name"
        required
      />
    </div>
    <div class="mb-2">
      <label for="carrierCode" class="form-label required">Carrier Code</label>
      <input
        type="text"
        class="form-control"
        placeholder="Enter Carrier Code"
        name="carrierCode"
        #carrierCode="ngModel"
        [(ngModel)]="carrierObj.carrierCode"
        id="carrierCode"
        required
      />
    </div>

    <div class="mb-2">
      <label for="description" class="form-label">Description</label>
      <textarea
        class="form-control"
        placeholder="Enter Description"
        [(ngModel)]="carrierObj.description"
        id="description"
        rows="4"
        style="resize: vertical"
      ></textarea>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="mb-2">
          <label for="email" class="form-label required">Email</label>
          <input
            type="email"
            class="form-control"
            placeholder="Enter Email"
            name="email"
            #email="ngModel"
            [(ngModel)]="carrierObj.email"
            id="email"
            required
            (ngModelChange)="isSaveDisabled()"
          />
          <div class="text-danger" *ngIf="validationErrors.carrierEmail">
            {{ validationErrors.carrierEmail }}
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="phoneNumber" class="form-label required">Phone Number</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Phone Number"
            name="phoneNumber"
            #phoneNumber="ngModel"
            [(ngModel)]="carrierObj.phoneNumber"
            id="phoneNumber"
            required
            (ngModelChange)="isSaveDisabled()"
          />
          <div class="text-danger" *ngIf="validationErrors.carrierPhone">
            {{ validationErrors.carrierPhone }}
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="fax" class="form-label">Fax</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Fax"
            [(ngModel)]="carrierObj.fax"
            id="fax"
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="websiteUrl" class="form-label">Website</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Website URL"
            [(ngModel)]="carrierObj.websiteUrl"
            id="websiteUrl"
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="status" class="form-label required">Status</label>
          <select class="form-select" [(ngModel)]="carrierObj.status" id="status" required>
            <option [ngValue]="CarrierStatus.Active">Active</option>
            <option [ngValue]="CarrierStatus.Inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div class="col-6 d-flex align-items-center">
        <div class="form-check mt-4">
          <input
            class="form-check-input"
            type="checkbox"
            [(ngModel)]="carrierObj.isDefault"
            id="isDefault"
          />
          <label class="form-check-label ms-2 mt-1" for="isDefault">Is Default</label>
        </div>
      </div>
    </div>

    <hr class="my-3" />
    <h6 class="mb-2">Primary Contact</h6>
    <div class="row">
      <div class="col-6">
        <div class="mb-2">
          <label for="firstName" class="form-label required">First Name</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter First Name"
            [(ngModel)]="carrierObj.primaryContact.firstName"
            id="firstName"
            required
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="lastName" class="form-label required">Last Name</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Last Name"
            [(ngModel)]="carrierObj.primaryContact.lastName"
            id="lastName"
            required
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="contactEmail" class="form-label required">Email</label>
          <input
            type="email"
            class="form-control"
            placeholder="Enter Email"
            [(ngModel)]="carrierObj.primaryContact.email"
            id="contactEmail"
            required
            (ngModelChange)="isSaveDisabled()"
          />
          <div class="text-danger" *ngIf="validationErrors.contactEmail">
            {{ validationErrors.contactEmail }}
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="contactPhone" class="form-label required">Phone Number</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Phone Number"
            [(ngModel)]="carrierObj.primaryContact.phoneNumber"
            id="contactPhone"
            required
            (ngModelChange)="isSaveDisabled()"
          />
          <div class="text-danger" *ngIf="validationErrors.contactPhone">
            {{ validationErrors.contactPhone }}
          </div>
        </div>
      </div>
    </div>

    <hr class="my-3" />
    <h6 class="mb-2">Address</h6>
    <div class="row mb-4">
      <div class="col-6">
        <div class="mb-2">
          <label for="line1" class="form-label required">Address Line 1</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Line 1"
            [(ngModel)]="carrierObj.address.line1"
            id="line1"
            required
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="line2" class="form-label">Address Line 2</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Line 2"
            [(ngModel)]="carrierObj.address.line2"
            id="line2"
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="city" class="form-label required">City</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter City"
            [(ngModel)]="carrierObj.address.city"
            id="city"
            required
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="zipCode" class="form-label required">Zip Code</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Zip Code"
            [(ngModel)]="carrierObj.address.zipCode"
            id="zipCode"
            required
            (ngModelChange)="isSaveDisabled()"
          />
          <div class="text-danger" *ngIf="validationErrors.zipCode">
            {{ validationErrors.zipCode }}
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="stateName" class="form-label required">State</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter State"
            [(ngModel)]="carrierObj.address.stateName"
            id="stateName"
            required
          />
        </div>
      </div>

      <div class="col-6">
        <div class="mb-2">
          <label for="countryName" class="form-label required">Country</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Country"
            [(ngModel)]="carrierObj.address.countryName"
            id="countryName"
            required
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="offcanvas-footer sticky-bottom py-2">
  <div class="d-flex justify-content-end">
    <button type="button" class="back-btn me-3 w-50" data-bs-dismiss="offcanvas">Cancel</button>
    <div (mousedown)="showRequiredFieldsMessage($event)" class="w-50">
      <button
        type="submit"
        class="btn pri-btn"
        (click)="manageCarrierOperation()"
        [disabled]="isLoading || isSaveDisabled()"
      >
        {{ carrierObj.id > 0 ? 'Update Carrier' : 'Add New Carrier' }}
      </button>
    </div>
  </div>
</div>
